export const KEYBOARD_KEY = {
  enter: 'Enter',
  backspace: 'Backspace'
}

export const KEYBOARD_KEYCODE = {
  ime: 229
}
